var render = function render(){var _vm=this,_c=_vm._self._c;return _c('brand-aggregate-page',{attrs:{"storage-key":"taofukeBrandListData","default-title":"十节优选","empty-icon":"🛍️"}})
}
var staticRenderFns = []

export { render, staticRenderFns }